// The two colour helpers the charts share: a theme token at partial opacity, and the vertical
// fade a filled area series takes.

/**
 * One of a chart's colours at partial opacity. The tokens are hex, and the two places a chart needs
 * one see-through - a reference halo behind its own primary series, and the fade under a filled area
 * - both need it as a colour value rather than as an element opacity, which would take the series'
 * own line with it.
 */
export function withAlpha(hex: string, alpha: number): string {
    // Some theme tokens are three-digit (`#fff`), which parses as a different colour entirely
    // unless each digit is doubled first.
    const digits = hex.slice(1);
    const value = parseInt(digits.length === 3 ? digits.replace(/(.)/g, '$1$1') : digits, 16);
    const r = Math.floor(value / 65536) % 256;
    const g = Math.floor(value / 256) % 256;
    const b = value % 256;
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

/**
 * The fill for a filled area series: its own colour at the curve, fading to nothing at the axis. A
 * flat fill under a dense trace reads as a solid block whose top edge is the only thing carrying
 * information; the fade leaves the eye on the curve while still tying it to its baseline. Same
 * treatment the backend's own realtime water chart uses for its hourly view
 * (WaterConsumptionChartStrategy).
 */
export function verticalFade(hex: string) {
    return {
        linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
        stops: [
            [0, withAlpha(hex, 0.75)],
            [1, withAlpha(hex, 0)],
        ] as Array<[number, string]>,
    };
}
